module.exports = __webpack_public_path__ + "static/media/ALZ-PH-WALMART.ed834e90.png";